export const data = [
  {
    id: 1,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 2,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 3,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 4,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 5,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 6,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 7,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 8,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 9,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 10,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 11,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 12,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 13,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 14,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
  {
    id: 15,
    location: "Ansan",
    operator: "Bob Mark",
    orderprice: "150,000",
    user: "Muhammad Ali",
    phone: "10 1133 3344",
    sana: new Date(),
    time: new Date(),
  },
];
